module.exports = __webpack_public_path__ + "static/nodejs-ddd-f35026aba92797de1ad2bd1e5df0bf00.png";